var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5845 0.484253H4.41533C1.98072 0.484253 0 2.08311 0 4.04827V9.83503C0 11.8003 1.98072 13.399 4.41533 13.399H11.5845C14.0193 13.399 16 11.8002 16 9.83503V4.04827C16.0001 2.08311 14.0193 0.484253 11.5845 0.484253ZM14.5805 9.83503C14.5805 11.1684 13.2365 12.2532 11.5846 12.2532H4.41533C2.76348 12.2533 1.4196 11.1684 1.4196 9.83503V4.04827C1.4196 2.71494 2.76348 1.63012 4.41533 1.63012H11.5845C13.2364 1.63012 14.5804 2.71494 14.5804 4.04827V9.83503H14.5805Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00024 3.61401C5.7269 3.61401 3.87744 5.10685 3.87744 6.94185C3.87744 8.77677 5.7269 10.2695 8.00024 10.2695C10.2736 10.2695 12.123 8.77677 12.123 6.94185C12.123 5.10685 10.2736 3.61401 8.00024 3.61401ZM8.00024 9.12359C6.50976 9.12359 5.29704 8.14486 5.29704 6.94177C5.29704 5.73861 6.50966 4.75981 8.00024 4.75981C9.49082 4.75981 10.7034 5.73861 10.7034 6.94177C10.7034 8.14486 9.49073 9.12359 8.00024 9.12359Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2959 2.64246C12.0224 2.64246 11.7537 2.73183 11.5606 2.88843C11.3665 3.04426 11.2549 3.2612 11.2549 3.48273C11.2549 3.70357 11.3666 3.92043 11.5606 4.07703C11.7536 4.23286 12.0224 4.323 12.2959 4.323C12.5703 4.323 12.8382 4.23286 13.0322 4.07703C13.2262 3.92043 13.3369 3.70349 13.3369 3.48273C13.3369 3.2612 13.2262 3.04426 13.0322 2.88843C12.8391 2.73183 12.5703 2.64246 12.2959 2.64246Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4557903770572b39e1de09c7d6589c39.svg";
export { ForwardRef as ReactComponent };